"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALTIUM_CONNECTION_TOLERANCE = exports.ALTIUM_POINT_ROUNDING_PRECISION = void 0;
exports.ALTIUM_POINT_ROUNDING_PRECISION = 0.01;
exports.ALTIUM_CONNECTION_TOLERANCE = 0.03;
//# sourceMappingURL=AltiumCombobulatorConfig.js.map